import { jump, getDataThrowToMicroapp } from '@/pages/activity-manage/merchants/venue-detail/constants/index';
import type { DataType } from '@/pages/activity-manage/merchants/venue-detail/constants/index';
import { getQuery } from '@/common/utils';
import queryString from 'query-string';
import { getRootPath } from '../util';

const handelParams = (query: string = '') => {
  const [pathname, realQuery] = query.split('?');
  const queryObj = queryString.parse(realQuery);

  if (!queryObj.channelId) {
    const channelId = getQuery('channelId');
    if (channelId) queryObj.channelId = channelId;
  }

  if (!queryObj.resourceId) {
    const resourceId = getQuery('resourceId');
    if (resourceId) queryObj.resourceId = resourceId;
  }
  if (!queryObj.activityId) {
    const activityId = getQuery('activityId');
    if (activityId) queryObj.activityId = activityId;
  }

  if (!queryObj.blockId && queryObj.areaId) {
    queryObj.blockId = queryObj.areaId;
  }
  if (!queryObj.entry && getQuery('entry')) {
    queryObj.entry = getQuery('entry');
  }

  if (location.pathname.includes('/distribute')) {
    queryObj.tabFrom = 'distribute';
  }

  return `${pathname}?${queryString.stringify(queryObj)}${
    getQuery('forceIntoManage') === '1' ? '&forceIntoManage=1' : ''
  }`;
};

export const baseLink = `/${getRootPath()}/resource-detail/material-collection`;

const data = getPlatformAndChannelData(baseLink);

// eslint-disable-next-line
function getPlatformAndChannelData(baseLink: string): DataType {
  const innerData = getDataThrowToMicroapp({ baseLink });

  return {
    ...innerData,
    inPlatformMarketing: true,
    jumpCollectionPoolSettings: (query, type) => {
      jump(baseLink + '/poolSetting' + handelParams(query), type);
    },
    // 管理者者提报收品池列表 & 效果数据
    jumpCollection: (query, type) => {
      jump(baseLink + '/distribute/roomlist' + handelParams(query), type);
    },
    // 参与者收品池列表 & 效果数据
    jumpPoolList: (query, type) => {
      jump(baseLink + '/distribute/roomlist' + handelParams(query), type);
    },

    jumpManage(pathSuffix, type) {
      jump(baseLink + '/managemc' + handelParams(pathSuffix), type);
    },
    // 分配
    jumpDistributePage: (query, type) => {
      jump(baseLink + '/distributePage/index' + handelParams(query), type);
    },
    // 报名
    jumpSignUp: (query, type) => {
      jump(baseLink + '/signUp' + handelParams(query), type);
    },
    // 资质设置
    jumpQualificationSettings: (query, type) => {
      jump(baseLink + '/qualification' + handelParams(query), type);
    },
    // 资质平台页面
    jumpQualificationForAssembly: (query, type) => {
      jump(baseLink + '/qualificationForAssembly' + handelParams(query), type);
    },
    // 跨场次跳转
    jumpCrossSessionJumps: (query, type) => {
      jump(baseLink + '/crossSessionJumps/batchEditInfo' + handelParams(query), type);
    },

    // 跳转到venues
    jumpVenues: (query, type) => {
      jump(baseLink + '/venues' + handelParams(query), type);
    },
    jumpVenuesPageDetail: (query, type) => {
      jump(baseLink + '/venuesPageDetail' + handelParams(query), type);
    },
    // 效果数据 在日常活动和频道阵地中被嵌入
    jumpEffectData(query, type) {
      // 管理者 jumpCollection
      // 参与者 jumpPoolList
      // 活动会场跳转的是列表页
      // entry: 1 参与者 0 管理者
      // const entry = utils.getQuery('entry', query);
      // if (entry === '1') return data.jumpPoolList(query, type);
      // if (entry === '0') return data.jumpCollection(query, type);
      return jump(
        baseLink +
          `/${window.location.href.includes('distribute') ? 'distribute' : 'invite'}/effectData` +
          handelParams(query),
        type
      );
    },
    // 流程数据 在日常活动和频道阵地中被嵌入
    jumpActivityData(query, type) {
      // 我和上面的如果没有流程数据就可以删掉了
      jump(
        baseLink +
          `/${window.location.href.includes('distribute') ? 'distribute' : 'invite'}/manage/activityData/detail` +
          query,
        type
      );
    },
  };
}

// 营销阵地内嵌页跳转方法
export const platformData = getPlatformAndChannelData(`/platform-marketing/resource-detail/material-collection`);

// 行业频道内嵌页跳转方法
export const industryData = getPlatformAndChannelData(`/channel-service/position/resource-detail/material-collection`);

export default data;
